import { Component, OnInit } from '@angular/core';
import { GlobalConstantsService } from '../../services/global-constants.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-global-constants',
  templateUrl: './global-constants.component.html'
})
export class GlobalConstantsComponent implements OnInit {
  fields: Array<any> = [];

  constructor(
    private globalConstantsService: GlobalConstantsService,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
    this.globalConstantsService.getAll().map(fields => {
      return fields.filter(field => {
        return field.scope === 'global';
      });
    }).subscribe(fields => {
      this.fields = fields;
    });
  }

  delete(field, index: number) {
    this.globalConstantsService.delete(field.id).subscribe(() => {
      this.fields.splice(index, 1);
      this.toasterService.pop('success', 'Success', 'Constant deleted');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/global-constants/global-constants.component.ts